module.exports = __webpack_public_path__ + "static/img/team-gz-01.f4ec6f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team-gz-01.png
// module id = +79k
// module chunks = 1